// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ProgressBar_barWrapper__ZyV0l {
    background: var(--color-107);
    height: 20px;
    overflow: hidden;
}

.ProgressBar_bar__vAaXs {
    background: var(--color-102);
    height: inherit;
    transition: width .4s;
    max-width: 100%;
}

.ProgressBar_rounded__-3p9r {
    border-radius: 9999px;
}

@media only screen and (max-width: 47.9375em) {
    .ProgressBar_barWrapper__ZyV0l {
        height: 10px;
    }
}`, "",{"version":3,"sources":["webpack://./node_modules/ui-connect/ProgressBar/ProgressBar.module.css"],"names":[],"mappings":"AAAA;IACI,4BAA4B;IAC5B,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,4BAA4B;IAC5B,eAAe;IACf,qBAAqB;IACrB,eAAe;AACnB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI;QACI,YAAY;IAChB;AACJ","sourcesContent":[".barWrapper {\n    background: var(--color-107);\n    height: 20px;\n    overflow: hidden;\n}\n\n.bar {\n    background: var(--color-102);\n    height: inherit;\n    transition: width .4s;\n    max-width: 100%;\n}\n\n.rounded {\n    border-radius: 9999px;\n}\n\n@media only screen and (max-width: 47.9375em) {\n    .barWrapper {\n        height: 10px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"barWrapper": `ProgressBar_barWrapper__ZyV0l`,
	"bar": `ProgressBar_bar__vAaXs`,
	"rounded": `ProgressBar_rounded__-3p9r`
};
export default ___CSS_LOADER_EXPORT___;
